/** Website single-issue purchases: only last N calendar months. */
export const ISSUE_PURCHASE_WINDOW_MONTHS = 6;

export function parseIssuePublicationDate(issue) {
  if (!issue) return null;
  const raw = issue.publication_date;
  if (raw) {
    const d = new Date(raw);
    if (!Number.isNaN(d.getTime())) return d;
  }
  const my = String(issue.month_year || '').trim();
  if (!my) return null;
  const d2 = new Date(`${my} 1`);
  if (!Number.isNaN(d2.getTime())) return d2;
  return null;
}

export function issuePurchaseCutoffDate(months = ISSUE_PURCHASE_WINDOW_MONTHS, now = new Date()) {
  const d = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  d.setMonth(d.getMonth() - months);
  return d;
}

/** True when issue can be bought on the public website. */
export function isIssuePurchasable(issue, months = ISSUE_PURCHASE_WINDOW_MONTHS) {
  if (issue && typeof issue.is_purchasable === 'boolean') {
    return issue.is_purchasable;
  }
  const pub = parseIssuePublicationDate(issue);
  if (!pub) return false;
  return pub.getTime() >= issuePurchaseCutoffDate(months).getTime();
}

export function issuePurchaseBlockedMessage(months = ISSUE_PURCHASE_WINDOW_MONTHS) {
  return `Only magazines from the last ${months} months can be purchased.`;
}
